<template>
	<article v-if="data.id" class="nhk-item" :class="'item-' + data.id">
		<WpLink class="post-link" :url="data.link" :title="data.title">
			<div class="info">
				<h2 class="titler" v-html="data.title"></h2>
				<div class="description" v-if="data.acf && data.acf.introtext" v-html="data.acf.introtext"></div>
			</div>
			<span class="arrow-link" v-html="arrow"></span>
		</WpLink>
	</article>
</template>

<script>
import WpLink from '@/components/elements/WpLink'
import { arrow } from '@/components/../icons'

export default {
	name: 'NHK-Item',
	props: ['data'],
	components: {
		WpLink,
	},
	data() {
		return {
			arrow: arrow('var(--dark)'),
		}
	},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';

.nhk-item {
	display: flex;
	.post-link {
		text-decoration: none;
		display: block;
		background-color: var(--gray);
		padding: 20px;
		width: 100%;
		display: flex;
		box-shadow: inset 0 0 0 2px transparent;
		transition: box-shadow 0.2s ease-in-out;
		&:hover {
			box-shadow: inset 0 0 0 2px var(--dark);
		}
		.description {
			@include fluid-type($smallResText, $wideResText, 12px, 15px);
		}
		.info {
			flex: 1;
			padding-right: 20px;
		}

		.titler {
			text-transform: uppercase;
			@include fluid-type($smallResText, $wideResText, 16px, 20px);
			margin-top: 0;
			margin-bottom: 15px;
		}
	}
}
</style>
